/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentCurrentUser.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Currently Logged In User API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 8:34 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const CurrentUserProfile = {
    get: () => requests.get('/CurrentUser')
}